import React, { useEffect, useState } from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import TableChart from '@/pages/intelligence/components/TableComponents/components/TableChart';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
interface ColumnType {
  key: string;
  title: string;
  currentSortKey: string;
  currentSortValue: '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: React.ReactNode;
  isNoDropdown?: boolean;
  svgIcon?: any;
  metricKey?: string;
  entityType?: string
  sortByDropdownBoxClassName?: string;
}

export const DemographicsCloums = (params: ColumnType) => {
  const {
    key,
    title,
    sortMetric,
    currentSortKey,
    currentSortValue,
    textContent,
    onSortChage,
    formatMessage = () => console.log,
    getMetricValueOfCvm,
    renderType,
    ageSortList = [],
    width = 180,
    dataSource,
    metricKey,
    entityType = '',
    sortByDropdownBoxClassName,
    isNoDropdown,
  } = params;

  const align = renderType === RenderType.TABLE_BAR_CHART ? 'left' : 'right';
  return {
    key: key,
    width: width,
    header: (
      <CloumsCenter width={width} align={align}>
        <SortBy
          dropdownBoxClassName={sortByDropdownBoxClassName}
          align={align}
          title={title}
          defaultKey={currentSortKey}
          defaultValue={currentSortValue}
          svgIcon={dataSource ? getDataSourceIcon(dataSource) : null}
          list={
            key === 'gender'
              ? [
                  {
                    sortMetric: 'male',
                    key: 'male',
                    text: 'Male',
                    title: 'Male',
                    orderType: 'gender',
                  },
                  {
                    sortMetric: 'female',
                    key: 'female',
                    text: 'Female',
                    title: 'Female',
                    orderType: 'gender',
                  },
                ]
              : key === 'age'
              ? ageSortList
              : [
                  {
                    key: `${key}_0`,
                    sortMetric: sortMetric,
                    text: title,
                    title: title,
                    ratioType: 0,
                  },
                  {
                    key: `${key}_1`,
                    sortMetric: sortMetric,
                    text: `${title}:${formatMessage({ id: 'dbi_change' })}(%)`,
                    title: `${title}(%)`,
                    ratioType: 1,
                  },
                ]
          }
          onChange={onSortChage}
          content={textContent}
          isNoDropdown={isNoDropdown}
          svgTip={
            dataSource ? (
              <DataSourceBubbleInfo
                dataOfDom={<>{title}</>}
                metricKey={metricKey || sortMetric}
                entityType={entityType}
                comesFormDom={
                  <>
                    <img src={getDataSourceIcon(dataSource)} />
                    {DATASOURCE_NAME[dataSource]}
                  </>
                }
                dataSource={dataSource}
              />
            ) : null
          }
        />

      </CloumsCenter>
    ),
    align: 'center',
    render: (cvm: any) => {
      if (renderType === RenderType.TABLE_BAR_CHART) {
        const data =
          key === 'gender'
            ? {
                title: 'Gender',
                titleNow: 'Demographics%',
                list: cvm?.genderMetricList,
              }
            : {
                title: 'Age',
                titleNow: 'Demographics%',
                list: cvm?.ageMetricList,
              };
        return <TableChart tableData={data} />;
      } else {
        const { value, growthDataObj } = getMetricValueOfCvm(cvm, key);
        return (
          <CloumsCenter width={width} align={align}>
            <TableShowData
              maxNumber={'99999+%'}
              value={value}
              type={growthDataObj?.type}
              growth={growthDataObj?.value}
            />
          </CloumsCenter>
        );
      }
    },
  };
};
